/* eslint-disable camelcase */
import {
    SAVE_EQUITY_DETAILS_SUCCESS,
    SAVE_EQUITY_DETAILS_FAILURE,
    SET_EQUITY_CU_IN_PROGRESS,
    SET_EQUITY_ORDER_SUBMITTED,
} from '../actions/actionTypes';

import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import { removeEmptyFieldsFromObject } from 'src/utils/util';
import axios from 'src/api/Api';

export default function* saveEquity(action) {
    const url = `/occ/v2/${localStorage.getItem('baseSiteId')}/order/equity`;

    const payload = removeEmptyFieldsFromObject(action.payload);
    const isEquityOrderSubmitted = action.payload.isSAPSubmission;

    try {
        const result = yield axios
            .post(url, payload)
            .then((response) => response.data);
        // const result = yield saveEquityDataService(payload);
        // if (result.statusCode == RESPONSESUCCESS) {
        const modify_result = {
            ...result,
            isSubmitted: action.payload.isSubmitted,
        };
        yield put({
            type: SAVE_EQUITY_DETAILS_SUCCESS,
            data: modify_result,
        });
        !Object.prototype.hasOwnProperty.call(result, 'excludedProducts') ||
        result.excludedProducts.length == 0
            ? yield put({
                  type: SET_EQUITY_ORDER_SUBMITTED,
                  data: isEquityOrderSubmitted,
              })
            : null;
        yield put({ type: SET_EQUITY_CU_IN_PROGRESS, data: false });
        // }
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: payload
        });
        yield put({
            type: SAVE_EQUITY_DETAILS_FAILURE,
            data: {
                message: errorHandler('422'),
                statusCode: '422',
            },
        });
    }
}
